<Teranet-PageTitle i18n="@@contactus_title" [PageTitle]="'Contact Us'"></Teranet-PageTitle>
<div mat-dialog-content>
  <p i18n="@@contactus_whatever_your_question">Whatever your question or concern, we're here to help.</p>
  <br />
  <h6 i18n="@@contactus_general_question" style="padding: 0px;">General Questions and Support</h6>
  <mat-divider></mat-divider>
  <p>Contact Teranet at:&nbsp;<a href="mailto:{{emailGeneralQuestion}}">{{emailGeneralQuestion}}</a></p>
  <br />
  <h6 i18n="@@contactus_sale_market" style="padding: 0px;">Sales &amp; Marketing Requests or Product Demos</h6>
  <mat-divider></mat-divider>
  <p>
    <span i18n="@@contactus_email">
      Email:
    </span>
    &nbsp;<a href="mailto:{{emailSalesMarket}}">{{emailSalesMarket}}</a>
  </p>
</div>
<div mat-dialog-actions fxLayoutAlign="end">
  <button mat-raised-button class="theme-button" mat-dialog-close i18n="@@contactus_btn_close">Close</button>
</div>
